/**
 * Клієнтська діагностика з React-коду — той самий канал, що й boot_start у
 * `public/boot-guard.js`: POST /api/v1/client-error, на сервері рядок
 * `CLIENT_DIAG:` у логах api (без авторизації, рівень INFO, не в канал).
 *
 * 05.10.2026: у частини людей колесо крутилось без кінця, і з логів не було
 * видно, де саме воно висить. Тепер оберт сам повідомляє свої етапи.
 *
 * Без персональних даних: лише uid (як у boot_start), платформа й версія
 * Telegram і мітка збірки. Адресу сторінки НЕ шлемо — у ній initData з імʼям.
 * Помилка відправки ніколи не має зачепити інтерфейс.
 */
import { tg } from "@/lib/telegram";

export function reportDiag(kind: string, data: Record<string, unknown> = {}): void {
  try {
    const wa = tg() as (ReturnType<typeof tg> & { platform?: string; version?: string }) | null;
    let uid: number | null = null;
    try {
      uid = wa?.initDataUnsafe?.user?.id ?? null;
    } catch {
      uid = null;
    }
    const body = JSON.stringify({
      kind,
      uid,
      data,
      build: typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : null,
      tg: wa ? { platform: wa.platform ?? null, version: wa.version ?? null } : null,
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon("/api/v1/client-error", body);
    } else {
      void fetch("/api/v1/client-error", { method: "POST", body, keepalive: true }).catch(
        () => undefined,
      );
    }
  } catch {
    /* діагностика не має права ламати застосунок */
  }
}
